import styled from "@emotion/styled";
import { ArrowRight } from "@mui/icons-material";
import { Breadcrumbs, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { RequisitionRequestForm } from "../components/Forms/RequisitionRequestForm";

const Title = styled.h6`
  margin: 0;
  font-size: 12px;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  cursor: pointer;
`;

export const RequisitionRequest = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={2}>
      <Breadcrumbs
        separator={<ArrowRight fontSize="small" />}
        aria-label="breadcrumb"
      >
        <Title onClick={() => navigate("/finances/temp/expense")}>
          Expense
        </Title>
        <Title onClick={() => navigate("/finances/temp/expense/requisition")}>
          Requisition
        </Title>
        <Title bold>Request</Title>
      </Breadcrumbs>
      <RequisitionRequestForm />
    </Stack>
  );
};
